<template>
  <h5 class="mb-3 mt-5" style="text-align: center; margin-bottom: 15px">
    Ingreso a la Plataforma
  </h5>

  <div class="" style="position: relative">
    <p
      style="
        text-align: center;
        margin-bottom: 12px;
        font-size: 12px;
        font-weight: 600;
      "
    >
      ¿Eres nuevo?

      <span
        style="display: inline-block; position: relative; font-size: 15px"
        @mouseover="tooltipShow = true"
        @mouseleave="tooltipShow = false"
      >
        <i class="fa-solid fa-circle-info"></i>

        <span
          v-if="tooltipShow"
          style="
            position: absolute;
            top: -100%;
            left: 150%;
            background-color: #333333;
            color: #fdfdfd;
            padding: 10px;
            border-radius: 8px;
          "
          >Cuando inicies sesión con Google o Microsoft por primera vez, te
          registraremos automáticamente.</span
        >
      </span>
    </p>
  </div>

  <div class="text-center" style="margin: 15px 0 15px 0">
    <argon-button
      class="mt-1"
      id="btn_ingreso"
      variant="gradient"
      color="success"
      style="width: 100%"
      type="submit"
      size="lg"
      :disabled="isDisabled"
      @click="autenticacion('google')"
    >
      <i class="fa-brands fa-google" style="padding-right: 10px"></i>Iniciar
      Sesión con Google
    </argon-button>
  </div>

  <div class="text-center" style="margin: 15px 0 15px 0">
    <argon-button
      class="mt-1"
      id="btn_ingreso"
      variant="gradient"
      color="success"
      style="width: 100%"
      type="submit"
      size="lg"
      :disabled="isDisabled"
      @click="autenticacion('microsoft')"
    >
      <i class="fa-brands fa-microsoft" style="padding-right: 10px"></i>Iniciar
      Sesión con Microsoft
    </argon-button>
  </div>

  <p
    class="mt-6"
    style="text-align: center; margin-bottom: 12px; font-size: 14px"
  >
    ¿Problemas al Iniciar Sesión o Registrarte?
  </p>

  <a
    style="
      border-radius: 0.5rem;
      width: 100%;
      margin: 10px auto !important;
      padding: 10px 20px;
      background: #25d366 !important ;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-weight: 600;
    "
    class="btn btn-primary"
    href="https://api.whatsapp.com/send?phone=593979665549&text=¡Hola!%20No%20puedo%20Iniciar%20Sesión%20o%20Registrarme,%20ayuda."
    target="_blank"
  >
    <svg
      width="30"
      class="my-float"
      style="margin: 0; padding-right: 10px"
      height="30"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentcolor"
    >
      <path
        d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
      />
    </svg>
    Comunícate al WhatsApp</a
  >
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "vue-final-modal/style.css";
import authService from "@/services/authService";

export default {
  name: "formulario",
  components: {
    ArgonButton,
  },
  props: ["promoCode", "textoButton", "isLogin"],
  data() {
    return {
      user: {
        contrasena: "",
        dni: "",
      },
      isDisabled: false,
      showTerminos: false,
      countryCode: "",
      userData: null,
      isActive: true,
      tooltipShow: false,
      providerGoogle: new firebase.auth.GoogleAuthProvider(),
      providerMicrosoft: new firebase.auth.OAuthProvider("microsoft.com"),
      isInitializing: true,
    };
  },

  methods: {
    onInputChange() {
      this.user.dni = this.user.dni.replace(/\D/g, "").slice(0, 10);
    },

    contrasena() {
      this.isDisabled = false;
      this.password = "";
      this.showModal = false;
      this.showModalContraseña = true;
    },

    closed() {
      this.showModalContraseña = false;
    },

    async autenticacion(parameter) {
      if (this.isDisabled) return;

      this.isDisabled = true;

      try {
        // Configure provider
        if (parameter === "google") {
          this.providerGoogle.setCustomParameters({ prompt: "select_account" });
        } else if (parameter === "microsoft") {
          this.providerMicrosoft.setCustomParameters({
            prompt: "select_account",
          });
        }

        // Sign in with popup
        const result = await firebase
          .auth()
          .signInWithPopup(
            parameter === "google"
              ? this.providerGoogle
              : this.providerMicrosoft
          );

        const { user } = result;

        // Initialize auth service after successful authentication
        await authService.initialize();

        const userId_json = {
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          userLoginId: user.uid,
        };

        localStorage.setItem("userData", JSON.stringify(userId_json));

        this.$swal({
          html: '<div class="row"><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div><div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><div class="loader"> </div></div><div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><p style="margin:0px; font-size:16px; text-align:center; font-weight:bold">Iniciando sesión</p></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div></div>',
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          backdrop: true,
          showConfirmButton: false,
          position: "top",
        });

        // Tokens are automatically handled by axios interceptor

        const response = await this.$https.post("/login/acceso", {
          ...userId_json,
        });

        this.$swal.close();

        if (response.data.code == 204) {
          this.$store.state.user = JSON.stringify(userId_json);
          localStorage.setItem("userData", JSON.stringify(userId_json));
          this.$router.push({ name: "Register" });
          return;
        }

        if (response.data.code == 200) {
          this.userData = response.data.datos;
          let isNewUser = response.data.message;

          const role = response.data.role ?? "user";
          const userRole = this.$encryptBackoffice.encrypt(role);
          localStorage.setItem("session", userRole);

          if (isNewUser === "Ha completado el perfil  ") {
            this.showTerminos = true;
          } else {
            const userDataWithTokens = {
              ...this.userData,
              authToken: await authService.getIdToken(),
              appCheckToken: authService.getAppCheckToken(),
            };

            localStorage.setItem(
              "userData",
              JSON.stringify(userDataWithTokens)
            );
            this.$store.state.user = JSON.stringify(userDataWithTokens);

            if (this.isLogin) {
              this.$router.push({ name: "Dashboard" });
            } else {
              location.reload();
            }
          }
        } else {
          this.$toast.error(response.data.message, {
            position: "top-right",
            max: 10,
          });
        }
      } catch (error) {
        this.$swal.close();

        const errorCode = error.code;

        if (errorCode === "auth/popup-closed-by-user") {
          // User closed popup, no need to show error
        } else if (errorCode === "auth/user-disabled") {
          this.$toast.error(
            "Lo sentimos, su cuenta se encuentra inhabilitada actualmente",
            { position: "top-right", max: 10 }
          );
        } else if (
          errorCode === "auth/account-exists-with-different-credential"
        ) {
          this.$toast.error(
            "No es posible su logeo o registro porque esta cuenta ya se encuentra registrada",
            { position: "top-right", max: 10 }
          );
        } else {
          this.$toast.error("Ocurrió un error inesperado: " + error.message, {
            position: "top-right",
            max: 10,
          });
        }

        console.error("Authentication error:", error);
      } finally {
        this.isDisabled = false;
      }
    },

    async checkExistingSession() {
      try {
        const userData = localStorage.getItem("userData");
        if (!userData) {
          await authService.initialize();
          return;
        }

        // const user = JSON.parse(userData);

        // Check if we have a valid Firebase user
        if (authService.getCurrentUser()) {
          // User is still authenticated with Firebase
          await authService.initialize();
          return;
        }

        // If we reach here, user is not authenticated
        await authService.initialize();
      } catch (error) {
        console.error("Session check error:", error);
        await authService.initialize();
      }
    },
  },

  async mounted() {
    try {
      firebase.auth().useDeviceLanguage();
      await this.checkExistingSession();
    } catch (error) {
      console.error("Mount error:", error);
    } finally {
      this.isInitializing = false;
    }
  },

  beforeUnmount() {
    // Clean up any listeners if needed
  },
};
</script>

<style scoped>
.bg-gradient-success {
  background-image: linear-gradient(310deg, #08629e 0%, #0c75ba 100%);
}

.m-input.--md .m-input-input,
.m-input.--md .m-input-label {
  font-size: 12px !important;
  line-height: 1.5rem;
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  cursor: not-allowed;
  pointer-events: auto;
}

.cardForm {
  margin: 1rem;
  padding: 1rem;
  /* border: 1px solid #ddd; */
  border-radius: 0.5rem;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
}
.cardForm:hover {
  background-color: rgb(251, 251, 251);
}

.cardForm-text {
  font-weight: 600;
}

.cardForm-body {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}

.selected {
  background-color: rgb(
    126,
    12,
    126,
    0.12
  ); /* Change this to the color you want for selected cardForms */
}
.selected:hover {
  background-color: rgb(
    126,
    12,
    126,
    0.12
  ); /* Change this to the color you want for selected cardForms */
}

.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip .tooltiptext {
  visibility: visible; /* Change to visible for debugging */
  opacity: 1; /* Change to 1 for debugging */
  width: 200px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -100px;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
</style>
